import { httpClientErrorMappingSrc176Evid100 } from '@wix/error-handler-core/@wix/bi-logger-os-data/v2';
import { withoutDefaults } from '../util/withoutDefaults';
export function reportErrorResolutionBi(errorHandler, params) {
  var _errorCodesMap$applic;
  const {
    errorAccessor,
    errorCodesMap
  } = params;
  const {
    biLogger
  } = errorHandler;
  const {
    errorHandlerState,
    applicationError
  } = errorAccessor;
  const code = applicationError == null ? void 0 : applicationError.code;
  const applicationErrorMapping = errorCodesMap == null || (_errorCodesMap$applic = errorCodesMap.applicationError) == null ? void 0 : _errorCodesMap$applic[code];
  biLogger.report(withoutDefaults(httpClientErrorMappingSrc176Evid100)({
    error_opt_out: applicationErrorMapping === false,
    is_override_error: String(errorCodesMap != null),
    session_id: errorHandlerState == null ? void 0 : errorHandlerState.sessionId
  }));
}
//# sourceMappingURL=reportErrorResolutionBi.js.map